"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Index = void 0;
require("reflect-metadata");
var PACKAGE = __importStar(require("../package.json"));
var helper_const_1 = require("./const/helper.const");
var module_mapping_1 = require("./const/module.mapping");
var notes_mapper_const_1 = require("./const/notes-mapper.const");
var reference_object_const_1 = require("./const/reference-object.const");
//import { _AllComponents } from './modules/components/all-components';
var cash_dom_1 = __importDefault(require("cash-dom"));
var generator_const_1 = require("./const/dom-crud/generator.const");
var input_mapping_const_1 = require("./const/input.mapping.const");
var chatgpt_1 = require("./modules/fitki/chatgpt");
var inter_communication_service_1 = require("./services/inter-communication.service");
var lead_service_1 = require("./services/lead.service");
var module_handler_service_1 = require("./services/module-handler.service");
var object_service_1 = require("./services/object-service");
var offline_fms_service_1 = require("./services/offline-fms.service");
var settings_service_1 = require("./services/settings.service");
var tracker_service_1 = require("./services/tracker.service");
require("./services/translation");
var translation_1 = require("./services/translation");
var pre_select_service_1 = require("./services/pre-select.service");
var lodash_1 = require("lodash");
// let container = new Container();
var Index = /** @class */ (function () {
    function Index(settings) {
        var _a;
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.leadService = object_service_1.ObjectService.getInstance(lead_service_1.LeadService);
        this.interComService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.config.set = settings;
        this.$container = ((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.$container) || (0, cash_dom_1.default)('body');
    }
    Index.prototype.prepTenantFromUrlOrLocalStorage = function () {
        var magiclineKey = 'magiclineTenant';
        var urlParams = new URLSearchParams(location.search);
        var magiclineTenant = urlParams.get(magiclineKey);
        if (magiclineTenant === null || magiclineTenant === void 0 ? void 0 : magiclineTenant.length) {
            localStorage.setItem(magiclineKey, magiclineTenant);
        }
        var tenantKey = localStorage.getItem(magiclineKey);
        var magicLineUrl = "https://".concat(tenantKey, ".api.magicline.com");
        if (tenantKey === null || tenantKey === void 0 ? void 0 : tenantKey.length) {
            this.config.update('tenantKey', tenantKey);
            this.config.update('magicLineUrl', magicLineUrl);
        }
    };
    Index.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offlineRegex, token_1;
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        console.log('TRANSLATE MODULE');
                        translation_1.TranslationForWebpage.translateNode(document.body);
                        translation_1.TranslationForWebpage.observer.observe(document.body, { childList: true, subtree: true });
                        this.convertUrlParametersToLocalstorage();
                        this.leadService.createLead();
                        //sendFrontendMetadata()
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        if (typeof window !== 'undefined' && window.jQuery) {
                            console.error('JQUERY IS LOADED EXTERNALLY REMOVE IT ITS UNNECESSARY AND IS WASTING SPEED');
                        }
                        // OFFLINE FMS OTP VALIDATION
                        if ((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.otpFMS) === null || _b === void 0 ? void 0 : _b.regex) {
                            console.log('REGEX', this.config.get.otpFMS.regex);
                            offlineRegex = new RegExp(this.config.get.otpFMS.regex);
                            if (offlineRegex.test(location.href) && this.config.get.otpFMS.redirectOnTimeout) {
                                if (localStorage.getItem('otpToken') !== offline_fms_service_1.OTPFunnelService.getToken().urlToken) {
                                    //new qr code token
                                    this.leadService.hardNewLeadUUID();
                                }
                                token_1 = offline_fms_service_1.OTPFunnelService.updateToken();
                                if (!token_1) {
                                    console.error('SESSION INVALID');
                                    window.location.href = this.config.get.otpFMS.redirectOnTimeout;
                                }
                                console.log('REGEX', this.config.get.otpFMS.regex, token_1);
                                setInterval(function () {
                                    var res = offline_fms_service_1.OTPFunnelService.validateToken(+token_1.ts);
                                    if (!res) {
                                        window.location.href = _this.config.get.otpFMS.redirectOnTimeout;
                                    }
                                }, 1000);
                            }
                        }
                        this.prepTenantFromUrlOrLocalStorage();
                        object_service_1.ObjectService.getInstance(tracker_service_1.TrackerService).loadModule(this.config);
                        if (!(this.config.get && ((_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.tenantKey) === null || _d === void 0 ? void 0 : _d.length))) return [3 /*break*/, 2];
                        console.info("fitfms script \"".concat(process.env.environment, "\":"), PACKAGE.version, this.config.get.magicLineUrl);
                        // option to select a studio and membership before modules load
                        return [4 /*yield*/, new pre_select_service_1.PreselectService().checkPreselects()];
                    case 1:
                        // option to select a studio and membership before modules load
                        _h.sent();
                        object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService)
                            .subscribeGlobally()
                            .subscribe(function (data) { });
                        if (this.config.get.section.toLowerCase() === 'v2') {
                            (0, module_handler_service_1._BootstrapModules)(this.$container).then(function (data) {
                                // console.error(
                                //   'com sub global ',
                                //   data,
                                //   _AllBootstrappedModules(),
                                //   Object.values(_AllBootstrappedModules()).map((a) => a.instance.moduleKey + ' ' + a.instance.uid)
                                // )
                            });
                        }
                        else {
                            this.v1LegacyAdaption();
                        }
                        if ((_e = this.config.get.widgets) === null || _e === void 0 ? void 0 : _e.length) {
                            if (this.config.get.widgets.includes('chatgpt')) {
                                object_service_1.ObjectService.getInstance(chatgpt_1.ChatGPT).loadModule();
                            }
                        }
                        if ((_f = this.config.get) === null || _f === void 0 ? void 0 : _f.hideDebugInfos) {
                            console.error('NOTE YOU HAVE HIDDEN ANY DEV HINTS / LOGS ONLY RECOMMENDED FOR E.G. DEMOS');
                        }
                        if (this.config.get.environment === 'dev' && !((_g = this.config.get) === null || _g === void 0 ? void 0 : _g.hideDebugInfos)) {
                            console.info('Loading specific section: ', this.config.get.section, this.config.get);
                            (0, cash_dom_1.default)('body').prepend('<h4 style="color:red; width:100%; background: #ddd; text-align:center; margin:0;padding:0;">USING DEV SCRIPT FOR TESTING PURPOSES ONLY</h4>');
                            document.title = 'DEV SCRIPT: ' + document.title;
                        }
                        //Methods that are just called once per page
                        (0, helper_const_1._CollapseAndUncollapse)(this.$container);
                        (0, helper_const_1._DataHide)();
                        return [3 /*break*/, 3];
                    case 2:
                        console.info('No Tenantname provided by webflow');
                        _h.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Converts the url parameters to localstorage
     */
    Index.prototype.convertUrlParametersToLocalstorage = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var params = new URLSearchParams(window.location.search);
        if ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.preselectFromUrl) {
            var termId = (_d = (_c = params.get('term_id')) !== null && _c !== void 0 ? _c : params.get('term_Id')) !== null && _d !== void 0 ? _d : params.get('termId');
            if (termId) {
                (0, lodash_1.set)(this.config, 'get.checkout.preselectTermFromLocalstorage', true);
                localStorage.setItem(input_mapping_const_1._AllMappings.rateBundleTermId.uid, termId);
            }
            var clubId = (_g = (_f = (_e = params.get('club_id')) !== null && _e !== void 0 ? _e : params.get('club_Id')) !== null && _f !== void 0 ? _f : params.get('studioId')) !== null && _g !== void 0 ? _g : params.get('clubId');
            if (clubId) {
                (0, lodash_1.set)(this.config, 'get.location.preselectStudioFromLocalStorage', true);
                localStorage.setItem(input_mapping_const_1._AllMappings.studioId.uid, clubId);
            }
        }
        Object.values(input_mapping_const_1._AllMappings).forEach(function (_a) {
            var uid = _a.uid;
            if (params.has(uid) && (uid === 'studioId' || uid === 'studioName')) {
                localStorage.setItem(uid, params.get(uid));
            }
        });
    };
    /**
     * @deprecated
     * This is everything to make v1 still work in v2
     */
    Index.prototype.v1LegacyAdaption = function () {
        return __awaiter(this, void 0, void 0, function () {
            var moduleKey, blueprint, module_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        /**
                         * This is to ensure backwards compatibility
                         */
                        console.error('YOU ARE USING LEGACY CODE... THIS IS DEPRECATEDED PLEASE TRY TO MOVE ASAP... IF YOU DONT KNOW HOW ASK BENJAMIN');
                        moduleKey = this.config.get.section;
                        blueprint = module_mapping_1._LegacyMapping[moduleKey];
                        if (!blueprint) return [3 /*break*/, 2];
                        if (blueprint === null || blueprint === void 0 ? void 0 : blueprint.references) {
                            (0, reference_object_const_1._RefObjectFinder)(this.$container, blueprint.references);
                        }
                        (0, notes_mapper_const_1._MapNoteFields)(this.$container);
                        return [4 /*yield*/, (0, module_handler_service_1._BootstrapModule)(this.$container, blueprint)];
                    case 1:
                        module_1 = _a.sent();
                        //inject data into the modules
                        module_1.instance.$container = this.$container;
                        module_1.$container = this.$container;
                        // module.instance.module = module;
                        //start loading screen
                        (0, generator_const_1._CreateLoadingScreen)();
                        module_1.instance
                            .loadModule((0, helper_const_1._GetDataAttributesInModule)(this.$container))
                            .then(function () {
                            console.info(moduleKey + ' is done with loading');
                            (0, generator_const_1._DeleteLoadingScreen)();
                        })
                            .catch(function (e) {
                            (0, generator_const_1._DeleteLoadingScreen)();
                            console.error('ERROR LOADING MODULE ' + moduleKey, e);
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        console.error('NO SECTION IS DEFINED PLEASE SET SETTINGS.SECTION');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Index;
}());
exports.Index = Index;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var fittecObj = document === null || document === void 0 ? void 0 : document.fittec;
if (typeof fittecObj === 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
        //
        // if (_CheckIfExecutedInIframe()) {
        //   console.error('catched iframe');
        //   document.body.innerHTML = '';
        //   return;
        // }
        new Index(settings).loadModule();
    });
}
else {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.fittec.index = function (settings) {
        return new Index(settings);
    };
}
// container.bind<ApiWrapper>(ApiWrapper).toSelf().inSingletonScope();
// container.bind<LeadApi>(LeadApi).toSelf().inSingletonScope();
// const dom = container.resolve(Index);
